<template>
  <!--
          Desktop columns:
          MD - 2 columns (50/50 configurator - filters)
          LG - 3 columns (66/33)
          XL - 4 columns (75/25)
           -->
  <div class="fixed inset-0 z-20 w-full bg-white">
    <div class="flex h-full w-full flex-col">
      <ConfiguratorHeader
        v-if="extraOptionsStore.productOptionsCategories.length > 0"
        class="h-14"
      />
      <div
        :class="noFooter ? 'overflow-y-scroll' : 'overflow-y-hidden'"
        class="grow grid-cols-2 md:grid lg:grid-cols-3"
      >
        <slot name="default" />
      </div>
      <div
        v-if="!noFooter"
        class="z-10 border-t border-white-darker bg-white py-3 md:h-20"
      >
        <div class="relative px-4 md:hidden">
          <ConfiguratorMobileFooter />
        </div>
        <div
          class="hidden h-full grid-cols-2 items-center md:grid lg:grid-cols-3"
        >
          <ConfiguratorDesktopFooter />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useConfiguratorStore } from '@/stores/Configurator/ConfiguratorStore';
import { useExtraOptionsStore } from '@/stores/ExtraOptionsStore';
import { ConfiguratorStep } from '@/types/Configurator/ConfiguratorStep';
import { computed, ComputedRef } from 'vue';
import ConfiguratorDesktopFooter from './ConfiguratorFooter/ConfiguratorDesktopFooter.vue';
import ConfiguratorMobileFooter from './ConfiguratorFooter/ConfiguratorMobileFooter.vue';
import ConfiguratorHeader from './ConfiguratorHeaderDesktop.vue';

const extraOptionsStore = useExtraOptionsStore();
const configuratorStore = useConfiguratorStore();

const noFooter: ComputedRef<boolean> = computed(() =>
  [ConfiguratorStep.ProductPage, ConfiguratorStep.ExtraOptions].includes(
    configuratorStore.currentStep
  )
);
</script>
